const _ = require('./enum');
module.exports = {
  [_.NONE]: { id: _.NONE, label: 'No reason' },
  [_.DUPLICATE]: { id: _.DUPLICATE, label: 'Duplicate' },
  [_.MISSING_IDENTIFIER]: { id: _.MISSING_IDENTIFIER, label: 'Missing identifier' },
  [_.AMOUNT_DISCREPANCY]: { id: _.AMOUNT_DISCREPANCY, label: 'Amount discrepancy' },
  [_.OTHER]: { id: _.OTHER, label: 'Other' },
};
